import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AvisoLegal from "../pages/aviso-legal/page";
import Privacidad from "../pages/privacidad/page";
import Cookies from "../pages/cookies/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/aviso-legal",
    element: <AvisoLegal />,
  },
  {
    path: "/politica-de-privacidad",
    element: <Privacidad />,
  },
  {
    path: "/politica-de-cookies",
    element: <Cookies />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
